import React, { useState } from "react";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import { IconButton, Menu, MenuItem } from "@material-ui/core";

const OPEN_OPTION = { name: "Open" };

export const ShipmentListItemMenu = ({
  inventory,
  getPossiblePlacementLocations,
  handleOpen,
  handleClone,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [options, setOptions] = useState([OPEN_OPTION]);

  // The menu sits inside a clickable list row. Stop clicks here (and inside
  // the portaled Menu, since React events bubble through portals) from
  // reaching the row's onClick, which would open the shipment instead.
  const stopRowClick = (event) => event.stopPropagation();

  const handleClick = (event) => {
    event.stopPropagation();
    const possibleLocations = [
      OPEN_OPTION,
      ...getPossiblePlacementLocations(inventory),
    ];
    setOptions(possibleLocations);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleMenuSelect = (itm) => {
    if (itm.name === "Open") handleOpen(inventory);
    else handleClone(inventory, itm);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertOutlinedIcon />
      </IconButton>
      <Menu
        id="place-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        onClick={stopRowClick}
      >
        {options.map((option) => (
          <MenuItem
            key={option.name}
            selected={option.name === "Open"}
            onClick={() => handleMenuSelect(option)}
          >
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
